
import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { Card } from 'primereact/card';
// import ReactEcharts from "echarts-for-react";
import { Dropdown } from 'primereact/dropdown';
import DrillDown from "../assets/images/drilldown.png";
import { Button } from 'primereact/button';
import { Carousel } from 'primereact/carousel';
import { ProductService } from '../service/ProductService';
import thumb from '../assets/images/strength.png';
import improvementimg from '../assets/images/improvement.png';
import caretup from "../assets/images/caret-up.png";
import caretdown from "../assets/images/caret-down.png";
import thumbdown from '../assets/images/weakness.png';
import TopNav from "../components/common/topnav.component";
import Edvisiondarklogo from '../assets/images/edvision-logo-dark.svg';
import ReactEcharts from "echarts-for-react";
import { useDispatch, useSelector } from "react-redux";
import {
    fetchSTRENGTH_AND_WEAKNESS_DRILL_DOWN_CHART_GRADUATION, fetchSTRENGTH_AND_WEAKNESS_DRILL_DOWN_CHART, fetchImprovement_Tile_Report, fetchStrength_Tile_Report, fetchWeakness_Tile_Report
} from '../redux/slices/strengthweakness';
import TreeMapEcharts from '../components/tree-graph';
import LoaderContainer from "../components/LoaderContainer/LoaderContainer";
import AppliedFilters from "../components/filterComponent/AppliedFilters";
import { Tooltip } from "primereact/tooltip";
import ValueTooltip from "../components/Tooltip/valueTooltip";
import { format, getMetricDisplayValue } from "../utils";

export default function StrengthWeakness(props) {
    const dispatch = useDispatch();
    // const STRENGTH_AND_WEAKNESS_DRILL_DOWN_CHARTdata = useSelector(state => state.strengthweakness.STRENGTH_AND_WEAKNESS_DRILL_DOWN_CHART);
    const STRENGTH_AND_WEAKNESS_DRILL_DOWN_CHARTdata = useSelector(state => state.strengthweakness.STRENGTH_AND_WEAKNESS_DRILL_DOWN_CHART);
    const STRENGTH_AND_WEAKNESS_DRILL_DOWN_CHART_GRADUATIONdata = useSelector(state => state.strengthweakness.STRENGTH_AND_WEAKNESS_DRILL_DOWN_CHART_GRADUATION);
    const Improvement_Tile_Reportdata = useSelector(state => state.strengthweakness.Improvement_Tile_Report);
    const Improvement_Tile_Reportdataloading = useSelector(state => state.strengthweakness.Improvement_Tile_Reportloading);
    const Strength_Tile_Reportdata = useSelector(state => state.strengthweakness.Strength_Tile_Report);
    const Strength_Tile_Reportdataloading = useSelector(state => state.strengthweakness.Strength_Tile_Reportloading);
    const Weakness_Tile_Reportdata = useSelector(state => state.strengthweakness.Weakness_Tile_Report);
    const Weakness_Tile_Reportdataloading = useSelector(state => state.strengthweakness.Weakness_Tile_Reportloading);

    const STRENGTH_AND_WEAKNESS_DRILL_DOWN_CHARTloading = useSelector(state => state.netsales.STRENGTH_AND_WEAKNESS_DRILL_DOWN_CHARTloading);


    const [selectedoptions, setSelectedoptions] = useState('school_level');
    const [selectedoptions1, setSelectedoptions1] = useState('student_grade');
    const [selectedoptions2, setSelectedoptions2] = useState('student_ethnicity');
    const [selectedoptions3, setSelectedoptions3] = useState('student_gender');

    const [nestedFields, setNestedFields] = useState(["DIMENSION_1", "DIMENSION_2", "DIMENSION_3", "DIMENSION_4"]);
    const [valueFields, setValueFields] = useState(["ACTUAL_D1", "ACTUAL_D2", "ACTUAL_D3", "ACTUAL_D4"]);
    const [percentageFields, setPercentageFields] = useState(["NUMERIC_VALUE_D1", "NUMERIC_VALUE_D2", "NUMERIC_VALUE_D3", "NUMERIC_VALUE_D4"]);

    sessionStorage.setItem("selectedoptions", selectedoptions);
    sessionStorage.setItem("selectedoptions1", selectedoptions1);
    sessionStorage.setItem("selectedoptions2", selectedoptions2);
    sessionStorage.setItem("selectedoptions3", selectedoptions3);

    const [screenWidth, setScreenWidth] = useState(0);
    useEffect(() => {
        const handleResize = () => {
            if (typeof window !== 'undefined') {
                const screenWidth = window.innerWidth;
                setScreenWidth(screenWidth);
            }
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    var Strength_Tile_Reportdatanew = JSON.parse(JSON.stringify(Strength_Tile_Reportdata));
    if (Strength_Tile_Reportdatanew) {
        Strength_Tile_Reportdatanew.map((itr, index) => {
            if (itr["METRIC_NAME"] == "# of Graduates") {
                itr["color"] = "#3A3365"
                itr["order"] = 1
            } else {
                itr["order"] = index + 2
            }

        })
    }


    if (Strength_Tile_Reportdatanew) {
        Strength_Tile_Reportdatanew = Strength_Tile_Reportdatanew.slice().sort((a, b) => {
            return a.order - b.order
        })

    }



    const options = [
        { name: 'School Type', value: 'school_level' },
        { name: 'School Name', value: 'school_name' },
        { name: 'Grade Level', value: 'student_grade' },
        { name: 'Ethnicity', value: 'student_ethnicity' },
        { name: 'Gender', value: 'student_gender' },
        { name: 'Hispanic', value: 'student_hispanic' },
        { name: 'Free and Reduced Lunch', value: 'student_economically_disadvantaged' },
        { name: 'ELL', value: 'student_ell' },
    ];

    const options1 = [
        { name: 'School Type', value: 'school_level' },
        { name: 'School Name', value: 'school_official_name' },
        { name: 'Grade Level', value: 'student_grade' },
        { name: 'Ethnicity', value: 'student_ethnicity' },
        { name: 'Gender', value: 'student_gender' },
        // { name: 'Hispanic', value: 'student_hispanic' },
        { name: 'Free and Reduced Lunch', value: 'student_economically_disadvantaged' },
        { name: 'EL', value: 'student_ell' },
        { name: 'Students with Disabilities', value: 'student_special_ability' },
    ];

    const options2 = [
        { name: 'School Type', value: 'school_level' },
        { name: 'School Name', value: 'school_name' },
        { name: 'Grade Level', value: 'student_grade' },
        { name: 'Ethnicity', value: 'student_ethnicity' },
        { name: 'Gender', value: 'student_gender' },
        { name: 'Hispanic', value: 'student_hispanic' },
        { name: 'Free and Reduced Lunch', value: 'student_economically_disadvantaged' },
        { name: 'ELL', value: 'student_ell' },
    ];

    const options3 = [
        { name: 'School Type', value: 'school_level' },
        { name: 'School Name', value: 'school_name' },
        { name: 'Grade Level', value: 'student_grade' },
        { name: 'Ethnicity', value: 'student_ethnicity' },
        { name: 'Gender', value: 'student_gender' },
        { name: 'Hispanic', value: 'student_hispanic' },
        { name: 'Free and Reduced Lunch', value: 'student_economically_disadvantaged' },
        { name: 'ELL', value: 'student_ell' },
    ];

    useEffect(() => {
        // dispatch(fetchSTRENGTH_AND_WEAKNESS_DRILL_DOWN_CHART({
        //   "elasticQueryName": "STRENGTH_AND_WEAKNESS_DRILL_DOWN_CHART",
        //   "filters": [
        //   ],
        //   "dynamicColumns": [],
        // }));

        dispatch(fetchImprovement_Tile_Report({
            "elasticQueryName": "Improvement_Tile_Report",
            "filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": ["2027"], "excludeKeyword": false
            }],
            "grad_filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": ["2027"], "excludeKeyword": false
            }, {
                "columnName": "MEASURE_TYPE",
                "columnValue": ["All"],
                "excludeKeyword": false
            }, {
                "columnName": "SCHOOL_OFFICIAL_NAME",
                "columnValue": ["DistrictWide"],
                "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));

        dispatch(fetchStrength_Tile_Report({
            "elasticQueryName": "Strength_Tile_Report",
            "filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": ["2027"], "excludeKeyword": false
            }],
            "grad_filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": ["2027"], "excludeKeyword": false
            }, {
                "columnName": "MEASURE_TYPE",
                "columnValue": ["All"],
                "excludeKeyword": false
            }, {
                "columnName": "SCHOOL_OFFICIAL_NAME",
                "columnValue": ["DistrictWide"],
                "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));

        dispatch(fetchWeakness_Tile_Report({
            "elasticQueryName": "Weakness_Tile_Report",
            "filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": ["2027"], "excludeKeyword": false
            }],
            "grad_filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": ["2027"], "excludeKeyword": false
            }, {
                "columnName": "MEASURE_TYPE",
                "columnValue": ["All"],
                "excludeKeyword": false
            }, {
                "columnName": "SCHOOL_OFFICIAL_NAME",
                "columnValue": ["DistrictWide"],
                "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));
    }, [])


    const drilldown = {
        series: [{
            type: "tree",
            data: [{
                name: "Actual 76.9%",
                symbolSize: 10,
                itemStyle: {
                    color: '#4C80E4',
                    shadowColor: 'rgba(76, 128, 228, 1)',
                    shadowBlur: 10,
                    fill: true

                },
                children: [{
                    name: "Middle(81.4%)",
                    lineStyle: {
                        width: 20,
                        color: "rgb(164, 202, 84)"
                    },
                    symbolSize: 10,
                    label: {
                        show: true,
                        position: "left"
                    },

                },
                // second chart 
                {
                    name: "Elementrary(79.7%)",

                    lineStyle: {
                        width: 12,
                        color: "rgb(202, 84, 84)"
                    },
                    symbolSize: 10,

                }, {
                    name: "Combined Middle/High(56.9%)",
                    lineStyle: {
                        width: 20,
                        color: "rgb(164, 202, 84)"
                    },
                    symbolSize: 10,

                }, {
                    name: "Combined Elementry /Secondory(98.4%)",
                    lineStyle: {
                        width: 20,
                        color: "rgb(164, 202, 84)"
                    },
                    symbolSize: 10,
                }]
            }],
            label: {
                position: "left"
            }
        }]
    }

    const TooltipAttributes = ({ categorydescription, metric_grp, metric_num, school_year, metric_id}) => {
        return {
            'data-pr-tooltip': `${categorydescription} ${metric_grp == 'Assessment' ? (metric_num <= 0 ? (`${(metric_id == 10169 || metric_id == 10170) ? 'Winter' : 'Spring'} ${school_year - 1} from SY:${Number(school_year) - 2 + "-" + String(school_year - 1).slice(-2)}`) : (`${((metric_id == 10169 || metric_id == 10170) && school_year == 2025) ? 'Fall' : 'Spring'} ${school_year} from SY:${Number(school_year) - 1 + "-" + String(school_year).slice(-2)}`)) : ''}`,
            'data-pr-position': 'top',
            'data-pr-my': 'left-40 bottom',
            'data-pr-at': 'center top-5',
            'data-pr-className': metric_grp == 'Text' ? 'custom-tooltip-text' :'custom-tooltip',
            style: { cursor: 'pointer', marginTop: '3px', marginBottom: '3px' }
        }
    }

    const handleTreeOnClick = (node) => {
    }

    const handleNestedFieldChange = (values) => {
        setNestedFields(values);
    }


    const [products, setProducts] = useState(Strength_Tile_Reportdatanew);
    const [products1, setProducts1] = useState(Improvement_Tile_Reportdata);
    const [products2, setProducts2] = useState(Weakness_Tile_Reportdata);

    useEffect(() => {
        setProducts(Strength_Tile_Reportdatanew);
        setProducts1(Improvement_Tile_Reportdata);
        setProducts2(Weakness_Tile_Reportdata);
    }, [products, products1, products2]);

    // const [selectedmetric, setSelectedmetric] = useState("10002" || "10097");
    const [selectedmetric, setSelectedmetric] = useState();

    sessionStorage.setItem("strengthselectedmetric", selectedmetric);

    const [selectedmetricname, setSelectedmetricname] = useState();

    const firstTile = useMemo(() => {
        const combinedData = [
            ...Improvement_Tile_Reportdata,
            ...Weakness_Tile_Reportdata,
            ...Strength_Tile_Reportdata,
        ];

        return combinedData.find(tile => tile?.METRIC_ID && tile?.METRIC_NAME);
    }, [Improvement_Tile_Reportdata, Weakness_Tile_Reportdata, Strength_Tile_Reportdata]);

    useEffect(() => {
        if (firstTile) {
            setSelectedmetric(firstTile.METRIC_ID);
            setSelectedmetricname(firstTile.METRIC_NAME);
        }
    }, [firstTile]);

    useEffect(() => {
        const handleBeforeUnload = () => {
            window.sessionStorage.removeItem('allfilter');
            window.sessionStorage.removeItem('selectedoptions');
            window.sessionStorage.removeItem('selectedoptions1');
            window.sessionStorage.removeItem('selectedoptions2');
            window.sessionStorage.removeItem('selectedoptions3');
            window.sessionStorage.removeItem('strengthselectedmetric');
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);
    var defaultallfilter = JSON.parse(sessionStorage.getItem("allfilter"));

    useEffect(() => {
        // const body = {
        //     "elasticQueryName": "",
        //     "filters": [{ "columnName": "metric_id", "columnValue": [selectedmetric], "excludeKeyword": false }],
        //     "dynamicColumns": [{ columnName: "#{dimension_1}", columnValue: [selectedoptions] },
        //     { columnName: "#{dimension_2}", columnValue: [selectedoptions1] },
        //     { columnName: "#{dimension_3}", columnValue: [selectedoptions2] },
        //     { columnName: "#{dimension_4}", columnValue: [selectedoptions3] }],
        //     "pivotConfig": [],

        // };
        let body;
        if (defaultallfilter) {
            body = {
                "elasticQueryName": "",
                "filters": defaultallfilter.filters,
                "dynamicColumns": [{ columnName: "#{dimension_1}", columnValue: [selectedoptions] },
                { columnName: "#{dimension_2}", columnValue: [selectedoptions1] },
                { columnName: "#{dimension_3}", columnValue: [selectedoptions2] },
                { columnName: "#{dimension_4}", columnValue: [selectedoptions3] },
                { columnName: "#{metric_id}", columnValue: [selectedmetric] }
            ],
            };
        } else {
            body = {
                "elasticQueryName": "",
                "filters": [{ "columnName": "SCHOOL_YEAR", "columnValue": ["2027"], "excludeKeyword": false }],
                "dynamicColumns": [{ columnName: "#{dimension_1}", columnValue: [selectedoptions] },
                { columnName: "#{dimension_2}", columnValue: [selectedoptions1] },
                { columnName: "#{dimension_3}", columnValue: [selectedoptions2] },
                { columnName: "#{dimension_4}", columnValue: [selectedoptions3] },
                { columnName: "#{metric_id}", columnValue: [selectedmetric] }
            ],
            };
        }
        if(selectedmetric != null) {
            handleperformance(body)
        }
    }, [selectedoptions, selectedoptions1, selectedoptions2, selectedoptions3, selectedmetric]);

    const handleperformance = (body) => {
        dispatch(fetchSTRENGTH_AND_WEAKNESS_DRILL_DOWN_CHART(body));
        // dispatch(fetchSTRENGTH_AND_WEAKNESS_DRILL_DOWN_CHART_GRADUATION(body));
    }
    const handleTopTileFilterClick = (tile) => {
        setSelectedmetric(tile?.METRIC_ID)
        setSelectedmetricname(tile?.METRIC_NAME)
        // setSelectedmetricname("Graduation Rate")
    }
    const strength = (Strength_Tile_Reportdatanew) => {
        return (
            <Strength_Tile_Report clicker={Strength_Tile_Reportdatanew} clickerFunc={handleTopTileFilterClick} METRIC_ID={Strength_Tile_Reportdatanew?.METRIC_ID} METRIC_NAME={Strength_Tile_Reportdatanew?.METRIC_NAME}
                METRIC_TYPE={Strength_Tile_Reportdatanew?.METRIC_TYPE?.toLowerCase()}
                ACTUAL={getMetricDisplayValue(Strength_Tile_Reportdatanew?.ACTUAL, Strength_Tile_Reportdatanew?.LAST_PERIOD, Strength_Tile_Reportdatanew?.METRIC_GROUP)}
                LAST_PERIOD={getMetricDisplayValue(Strength_Tile_Reportdatanew?.LAST_PERIOD, Strength_Tile_Reportdatanew?.LAST_PERIOD_PY2, Strength_Tile_Reportdatanew?.METRIC_GROUP)}
                LAST_PERIOD_VARIANCE={getMetricDisplayValue(Strength_Tile_Reportdatanew?.LAST_PERIOD_VARIANCE, Strength_Tile_Reportdatanew?.LAST_PERIOD_VARIANCE_PY2, Strength_Tile_Reportdatanew?.METRIC_GROUP)}
                TARGET={Strength_Tile_Reportdatanew?.TARGET}
                TARGET_VARIANCE={Strength_Tile_Reportdatanew?.TARGET_VARIANCE}
                METRIC_DESCRIPTION={Strength_Tile_Reportdatanew?.METRIC_DESCRIPTION} SCHOOL_YEAR={Strength_Tile_Reportdatanew?.SCHOOL_YEAR}
                METRIC_GROUP={Strength_Tile_Reportdatanew?.METRIC_GROUP} NUMERIC_VALUE={Strength_Tile_Reportdatanew?.NUMERIC_VALUE}
            />
        );
    };
    const improvement = (Improvement_Tile_Reportdata) => {
        let METRIC_NAME = '';
        switch (Improvement_Tile_Reportdata?.METRIC_NAME) {
            case 'ACT21_Graduation':
                let result = Improvement_Tile_Reportdata?.METRIC_NAME.replace('_', '+')
                result = result.replace('ACT21', 'ACT 21').replace('Graduation', ' Graduation');
                METRIC_NAME = result;
                break;

            default:
                METRIC_NAME = Improvement_Tile_Reportdata?.METRIC_NAME
                break;
        }

        return (
            <Strength_Tile_Report clicker={Improvement_Tile_Reportdata} clickerFunc={handleTopTileFilterClick} METRIC_ID={Improvement_Tile_Reportdata?.METRIC_ID} METRIC_NAME={METRIC_NAME}
                ACTUAL={getMetricDisplayValue(Improvement_Tile_Reportdata?.ACTUAL, Improvement_Tile_Reportdata?.LAST_PERIOD, Improvement_Tile_Reportdata?.METRIC_GROUP)}
                TARGET={Improvement_Tile_Reportdata?.TARGET}
                TARGET_VARIANCE={Improvement_Tile_Reportdata?.TARGET_VARIANCE}
                LAST_PERIOD={getMetricDisplayValue(Improvement_Tile_Reportdata?.LAST_PERIOD, Improvement_Tile_Reportdata?.LAST_PERIOD_PY2, Improvement_Tile_Reportdata?.METRIC_GROUP)}
                LAST_PERIOD_VARIANCE={getMetricDisplayValue(Improvement_Tile_Reportdata?.LAST_PERIOD_VARIANCE, Improvement_Tile_Reportdata?.LAST_PERIOD_VARIANCE_PY2, Improvement_Tile_Reportdata?.METRIC_GROUP)}
                METRIC_DESCRIPTION={Improvement_Tile_Reportdata?.METRIC_DESCRIPTION} SCHOOL_YEAR={Improvement_Tile_Reportdata?.SCHOOL_YEAR}
                METRIC_GROUP={Improvement_Tile_Reportdata?.METRIC_GROUP} NUMERIC_VALUE={Improvement_Tile_Reportdata?.NUMERIC_VALUE}
                METRIC_TYPE={Improvement_Tile_Reportdata?.METRIC_TYPE?.toLowerCase()}
            />
        );
    };
    const weakness = (Weakness_Tile_Reportdata) => {
        return (
            <Strength_Tile_Report clicker={Weakness_Tile_Reportdata} clickerFunc={handleTopTileFilterClick} METRIC_ID={Weakness_Tile_Reportdata?.METRIC_ID} METRIC_NAME={Weakness_Tile_Reportdata?.METRIC_NAME}
                ACTUAL={getMetricDisplayValue(Weakness_Tile_Reportdata?.ACTUAL, Weakness_Tile_Reportdata?.LAST_PERIOD, Weakness_Tile_Reportdata?.METRIC_GROUP)}
                TARGET={Weakness_Tile_Reportdata?.TARGET}
                TARGET_VARIANCE={Weakness_Tile_Reportdata?.TARGET_VARIANCE}
                LAST_PERIOD={getMetricDisplayValue(Weakness_Tile_Reportdata?.LAST_PERIOD, Weakness_Tile_Reportdata?.LAST_PERIOD_PY2, Weakness_Tile_Reportdata?.METRIC_GROUP)}
                LAST_PERIOD_VARIANCE={getMetricDisplayValue(Weakness_Tile_Reportdata?.LAST_PERIOD_VARIANCE, Weakness_Tile_Reportdata?.LAST_PERIOD_VARIANCE_PY2, Weakness_Tile_Reportdata?.METRIC_GROUP)}
                METRIC_DESCRIPTION={Weakness_Tile_Reportdata?.METRIC_DESCRIPTION} SCHOOL_YEAR={Weakness_Tile_Reportdata?.SCHOOL_YEAR}
                METRIC_GROUP={Weakness_Tile_Reportdata?.METRIC_GROUP} NUMERIC_VALUE={Weakness_Tile_Reportdata?.NUMERIC_VALUE}
                METRIC_TYPE={Weakness_Tile_Reportdata?.METRIC_TYPE?.toLowerCase()}
            />
        );
    };




    const Strength_Tile_Report = (props) => {
        // const [selectedmetric, setSelectedmetric] = useState("10003");  
        return (
            <>
                <div id='cardtilesCustomer ' onClick={
                    () => props.clickerFunc(props.clicker)
                }>
                    {
                        props?.METRIC_ID == selectedmetric ? <div className=" text-center strength-vertical-slider">
                            <div className="">
                                <div className="strength-vertical-slider-active bg-[#27304a] w-full flex justify-between items-center px-2">
                                    <div className='w-full flex justify-between'>
                                        <Tooltip target=".custom-target-icon" />
                                        <div className="flex custom-target-icon mx-[3px]" {...TooltipAttributes({ categorydescription: props?.METRIC_DESCRIPTION, metric_grp: props?.METRIC_GROUP, metric_num: props?.clicker?.METRIC_NUMERATOR, school_year: props?.SCHOOL_YEAR, metric_id: props?.METRIC_ID })}>
                                            <div className=''>
                                                <h4 className="mb-1 firstrowtext py-3 text-left" style={{ fontSize: "14px" }}>{props?.METRIC_NAME != "# of Graduates" ? props?.METRIC_NAME : "Graduation Rate"}</h4>
                                                {/* {(props?.METRIC_GROUP == 'Assessment' || props?.METRIC_GROUP == 'Graduation') && <h4 className="text-black text-[10px] text-left">{`(${props?.METRIC_GROUP == "Graduation" ? 'Latest' : (props?.METRIC_ID == 10026 || props?.METRIC_ID == 10025) ? 'Winter' : 'Spring'} SY: ${props?.SCHOOL_YEAR - 2} - ${props?.SCHOOL_YEAR - 1})`}</h4>} */}
                                                {(props?.METRIC_GROUP == "Assessment") && <>  <h4 className="text-black text-[10px] text-left">
                                                    {props?.clicker?.METRIC_NUMERATOR <= 0
                                                        ? `(${(props?.METRIC_ID == 10026 || props?.METRIC_ID == 10025) ? 'Winter' : 'Spring'} ${props?.SCHOOL_YEAR - 1} from SY:${Number(props?.SCHOOL_YEAR) - 2 + "-" + String(props?.SCHOOL_YEAR - 1).slice(-2)})`
                                                        : `(${((props?.METRIC_ID == 10169 || props?.METRIC_ID == 10170) && props?.SCHOOL_YEAR == 2025) ? 'Fall' : 'Spring'} ${props?.SCHOOL_YEAR} from SY:${Number(props?.SCHOOL_YEAR) - 1 + "-" + String(props?.SCHOOL_YEAR).slice(-2)})`
                                                    }
                                                </h4></>}
                                                {(props?.METRIC_GROUP == "Graduation") && <>  <h4 className="text-black text-[10px] text-left">
                                                    {props?.clicker?.METRIC_NUMERATOR <= 0 ? `(Latest SY:${Number(props?.SCHOOL_YEAR) - 2 + "-" + Number(props?.SCHOOL_YEAR - 1)})` : `(Latest SY:${Number(props?.SCHOOL_YEAR) - 1 + "-" + Number(props?.SCHOOL_YEAR)})`}
                                                </h4></>}
                                            </div>
                                            {/* <div className=''><h4 className="mb-1 firstrowtext py-3 text-left" style={{ fontSize: "14px" }}>{props?.METRIC_NAME != "# of Graduates" ? props?.METRIC_NAME : "Graduation Rate"}</h4></div> */}
                                        </div>
                                        <div className=''>
                                            <ValueTooltip heading={props?.METRIC_NAME} value1={format(props?.ACTUAL, { suffix: props?.METRIC_TYPE === 'percentage' ? '%' : '', forcedecimals: props?.METRIC_TYPE === 'percentage' ? 1 : 0 })} value2={props?.METRIC_NAME?.startsWith('College') ? props?.NUMERIC_VALUE?.toFixed(1) + '%' : props?.NUMERIC_VALUE}>
                                                <h4 className="mb-1 strenth-pers py-3 text-right">
                                                    {format(props?.ACTUAL, { suffix: props?.METRIC_TYPE === 'percentage' ? '%' : '', forcedecimals: props?.METRIC_TYPE === 'percentage' ? 1 : 0 })}
                                                </h4>
                                            </ValueTooltip>
                                        </div>
                                    </div>
                                    <div className='w-full flex justify-between'>
                                        <div className=''><h4 className="mb-1 firstrowtext py-3 text-left" style={{ fontSize: "14px" }}><span className="custom-target-icon" {...TooltipAttributes({ categorydescription: 'Indicates the desired performance level and the variance from the current value.', metric_grp: 'Text' })}>Target</span> <span className='font-semibold'>{format(props?.TARGET, { suffix: props?.METRIC_TYPE === 'percentage' ? '%' : '', forcedecimals: props?.METRIC_TYPE === 'percentage' ? 1 : 0 })} </span>
                                            {
                                                props?.METRIC_NAME == "Refferal Rate" || props?.METRIC_NAME == "Referral Rate" ?
                                                    props?.TARGET_VARIANCE >= 0 ? <span className="bg-[#db685b] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretup} width={5} height={5} className="inline-block mr-1" alt="" /> {props?.TARGET_VARIANCE ? props?.TARGET_VARIANCE?.toFixed(1) + "%" : "-"}</span> :
                                                        <span className="bg-[#129C83] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretdown} width={5} height={5} className="inline-block mr-1" alt="" /> {props?.TARGET_VARIANCE ? props?.TARGET_VARIANCE?.toFixed(1) + "%" : "-"}  </span> :
                                                    props?.METRIC_NAME == "Suspension Rate" ?
                                                        props?.TARGET_VARIANCE >= 0 ? <span className="bg-[#db685b] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretup} width={5} height={5} className="inline-block mr-1" alt="" /> {props?.TARGET_VARIANCE ? props?.TARGET_VARIANCE?.toFixed(1) + "%" : "-"}</span> :
                                                            <span className="bg-[#129C83] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretdown} width={5} height={5} className="inline-block mr-1" alt="" /> {props?.TARGET_VARIANCE ? props?.TARGET_VARIANCE?.toFixed(1) + "%" : "-"}</span> :
                                                        props?.METRIC_NAME == "Chronic Absenteeism" || props?.METRIC_NAME == "Out of School Suspensions" || props?.METRIC_NAME == "In School Suspensions" || props?.METRIC_NAME == "Suspension Rate" || props?.METRIC_NAME == "Referral Rate" ?
                                                            props?.TARGET_VARIANCE <= 0 ? <span className="bg-[#129C83] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretdown} width={5} height={5} className="inline-block mr-1" alt="" /> {props?.TARGET_VARIANCE ? props?.TARGET_VARIANCE?.toFixed(1) + "%" : "-"}</span> :
                                                                <span className="bg-[#db685b] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretup} width={5} height={5} className="inline-block mr-1" alt="" /> {props?.TARGET_VARIANCE ? props?.TARGET_VARIANCE?.toFixed(1) + "%" : "-"}</span> :
                                                            props?.METRIC_NAME == "RLC Rate" ?
                                                                props?.TARGET_VARIANCE <= 0 ? <span className="bg-[#129C83] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretdown} width={5} height={5} className="inline-block mr-1" alt="" /> {props?.TARGET_VARIANCE ? props?.TARGET_VARIANCE?.toFixed(1) + "%" : "-"}</span> :
                                                                    <span className="bg-[#db685b] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretup} width={5} height={5} className="inline-block mr-1" alt="" /> {props?.TARGET_VARIANCE ? props?.TARGET_VARIANCE?.toFixed(1) + "%" : "-"}</span> :
                                                                props?.METRIC_NAME == "Expulsion Rate" ?
                                                                    props?.TARGET_VARIANCE >= 0 ? <span className="bg-[#db685b] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretup} width={5} height={5} className="inline-block mr-1" alt="" /> {props?.TARGET_VARIANCE ? props?.TARGET_VARIANCE?.toFixed(1) + "%" : "-"}</span> :
                                                                        <span className="bg-[#129C83] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretdown} width={5} height={5} className="inline-block mr-1" alt="" /> {props?.TARGET_VARIANCE ? props?.TARGET_VARIANCE?.toFixed(1) + "%" : "-"}</span> :
                                                                    props?.TARGET_VARIANCE >= 0 ? <span className="bg-[#129C83] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretup} width={5} height={5} className="inline-block mr-1" alt="" /> {props?.TARGET_VARIANCE ? props?.TARGET_VARIANCE?.toFixed(1) + "%" : "-"}</span> :
                                                                        <span className="bg-[#db685b] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretdown} width={5} height={5} className="inline-block mr-1" alt="" /> {props?.TARGET_VARIANCE ? props?.TARGET_VARIANCE?.toFixed(1) + "%" : "-"}</span>
                                            }
                                        </h4></div>
                                        <div className=''><h4 className="mb-1 firstrowtext py-3 text-left" style={{ fontSize: "14px" }}><span className="custom-target-icon" {...TooltipAttributes({ categorydescription: 'Shows the previous year’s value and the change compared to the current performance.', metric_grp: 'Text' })}>Last Year</span> <span className='font-semibold'> {format(props?.LAST_PERIOD, { suffix: props?.METRIC_TYPE === 'percentage' ? '%' : '', forcedecimals: props?.METRIC_TYPE === 'percentage' ? 1 : 0 })}</span>
                                            {
                                                props?.METRIC_NAME == "Refferal Rate" || props?.METRIC_NAME == "Referral Rate" ?
                                                    props?.LAST_PERIOD_VARIANCE >= 0 ? <span className="bg-[#db685b] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretup} width={5} height={5} className="inline-block mr-1" alt="" />{props?.LAST_PERIOD_VARIANCE ? props?.LAST_PERIOD_VARIANCE?.toFixed(1) : "-"}%</span> :
                                                        <span className="bg-[#129C83] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretdown} width={5} height={5} className="inline-block mr-1" alt="" />{props?.LAST_PERIOD_VARIANCE ? props?.LAST_PERIOD_VARIANCE?.toFixed(1) : "-"}%</span> :
                                                    props?.METRIC_NAME == "Suspension Rate" ?
                                                        props?.LAST_PERIOD_VARIANCE >= 0 ? <span className="bg-[#db685b] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretup} width={5} height={5} className="inline-block mr-1" alt="" />{props?.LAST_PERIOD_VARIANCE ? props?.LAST_PERIOD_VARIANCE?.toFixed(1) : "-"}%</span> :
                                                            <span className="bg-[#129C83] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretdown} width={5} height={5} className="inline-block mr-1" alt="" />{props?.LAST_PERIOD_VARIANCE ? props?.LAST_PERIOD_VARIANCE?.toFixed(1) : "-"}%</span> :
                                                        props?.METRIC_NAME == "Chronic Absenteeism" || props?.METRIC_NAME == "Out of School Suspensions" || props?.METRIC_NAME == "In School Suspensions" || props?.METRIC_NAME == "Suspension Rate" || props?.METRIC_NAME == "Referral Rate" ? props?.LAST_PERIOD_VARIANCE >= 0 ? <span className="bg-[#db685b] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretup} width={5} height={5} className="inline-block mr-1" alt="" />{props?.LAST_PERIOD_VARIANCE ? props?.LAST_PERIOD_VARIANCE?.toFixed(1) : "-"}%</span> :
                                                            <span className="bg-[#129C83] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretdown} width={5} height={5} className="inline-block mr-1" alt="" />{props?.LAST_PERIOD_VARIANCE ? props?.LAST_PERIOD_VARIANCE?.toFixed(1) : "-"}%</span> :
                                                            props?.METRIC_NAME == "RLC Rate" ?
                                                                props?.LAST_PERIOD_VARIANCE >= 0 ? <span className="bg-[#db685b] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretup} width={5} height={5} className="inline-block mr-1" alt="" />{props?.LAST_PERIOD_VARIANCE ? props?.LAST_PERIOD_VARIANCE?.toFixed(1) : "-"}%</span> :
                                                                    <span className="bg-[#129C83] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretdown} width={5} height={5} className="inline-block mr-1" alt="" />{props?.LAST_PERIOD_VARIANCE ? props?.LAST_PERIOD_VARIANCE?.toFixed(1) : "-"}%</span> :
                                                                props?.METRIC_NAME == "Expulsion Rate" ?
                                                                    props?.LAST_PERIOD_VARIANCE >= 0 ? <span className="bg-[#db685b] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretup} width={5} height={5} className="inline-block mr-1" alt="" />{props?.LAST_PERIOD_VARIANCE ? props?.LAST_PERIOD_VARIANCE?.toFixed(1) : "-"}%</span> :
                                                                        <span className="bg-[#129C83] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretdown} width={5} height={5} className="inline-block mr-1" alt="" />{props?.LAST_PERIOD_VARIANCE ? props?.LAST_PERIOD_VARIANCE?.toFixed(1) : "-"}%</span> :
                                                                    props?.LAST_PERIOD_VARIANCE >= 0 ? <span className="bg-[#129C83] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretup} width={5} height={5} className="inline-block mr-1" alt="" />{props?.LAST_PERIOD_VARIANCE ? props?.LAST_PERIOD_VARIANCE?.toFixed(1) : "-"}%</span> :
                                                                        <span className="bg-[#db685b] text-xs text-white px-1 rounded-full w-11" style={{ fontSize: "14px", position: "relative", left: "5px" }}><img src={caretdown} width={5} height={5} className="inline-block mr-1" alt="" />{props?.LAST_PERIOD_VARIANCE ? props?.LAST_PERIOD_VARIANCE?.toFixed(1) : "-"}%</span>
                                            }
                                        </h4></div>
                                    </div>
                                </div>
                            </div>
                        </div> :
                            <div className=" text-center strength-vertical-slider">
                                <div className="w-full flex justify-between items-center px-4 cursor-pointer">
                                    <div className="flex custom-target-icon" {...TooltipAttributes({ categorydescription: props?.METRIC_DESCRIPTION, metric_grp: props?.METRIC_GROUP, metric_num: props?.clicker?.METRIC_NUMERATOR, school_year: props?.SCHOOL_YEAR, metric_id: props?.METRIC_ID })}>
                                        <h4 className="mb-1 firstrowtext py-3 text-left">{props?.METRIC_NAME != "# of Graduates" ? props?.METRIC_NAME : "Graduation Rate"}</h4>
                                    </div>
                                    <ValueTooltip heading={props?.METRIC_NAME} value1={format(props?.ACTUAL, { suffix: props?.METRIC_TYPE === 'percentage' ? '%' : '', forcedecimals: props?.METRIC_TYPE === 'percentage' ? 1 : 0 })} value2={props?.METRIC_NAME?.startsWith('College') ? props?.NUMERIC_VALUE?.toFixed(1) + '%' : props?.NUMERIC_VALUE}>
                                        <h4 className="mb-1 firstrowtext py-3 text-right">
                                            {format(props?.ACTUAL, { suffix: props?.METRIC_TYPE === 'percentage' ? '%' : '', forcedecimals: props?.METRIC_TYPE === 'percentage' ? 1 : 0 })}
                                        </h4>
                                    </ValueTooltip>
                                </div>
                            </div>
                    }
                </div>
            </>
        );
    };

    // let finalDrilldownChartData = selectedmetricname == "Graduation Rate" ? STRENGTH_AND_WEAKNESS_DRILL_DOWN_CHART_GRADUATIONdata : STRENGTH_AND_WEAKNESS_DRILL_DOWN_CHARTdata
    let finalDrilldownChartData = selectedmetricname == "Graduation Rate" ? STRENGTH_AND_WEAKNESS_DRILL_DOWN_CHARTdata : STRENGTH_AND_WEAKNESS_DRILL_DOWN_CHARTdata


    return (
        <div className="body">
            <TopNav pagename="Strength & Weakness" pagenamedescription="Key Facts about the District" setUserData={props.setUserData} />
            <AppliedFilters pagename={"Strength & Weakness"}/>
            <div className="flex justify-between items-center mx-3 my-2 strength">
                <div className="wrapper-card2 w-full mx-2">
                    <div className="streweak-vertical-carousel">
                        <div className="">
                            <div className='flex justify-between items-center bg-[#0F0D0B] h-[40px] pr-2'>
                                <div className="px-3 flex items-center justify-start">
                                    <img src={thumb} style={{ height: 18, width: 18 }} alt="icon" />
                                    <div className="flex items-center custom-target-icon flex-nowrap"
                                        {...TooltipAttributes({ categorydescription: "KPIs that are performing above target and have improved compared to last year, showcasing strong performance." })}>
                                        <span className="text-base font-[400] mx-2">Strengths</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <LoaderContainer loading={Strength_Tile_Reportdataloading} width={"100%"} height={"245px"} className={'bg-slate-800'}>

                            <Carousel value={Strength_Tile_Reportdatanew} numVisible={5} numScroll={1} orientation="vertical" verticalViewPortHeight={screenWidth < 1040 ? "320px" : "295px"}
                                itemTemplate={strength}
                            />
                        </LoaderContainer>
                    </div>
                </div>
                <div className="wrapper-card2 w-full mx-2">
                    <div className="streweak-vertical-carousel">
                        <div className="">
                            <div className='flex justify-between items-center bg-[#0F0D0B] h-[40px] pr-2'>
                                <div className="px-3 flex items-center justify-start">
                                    <img src={improvementimg} style={{ height: 18, width: 18 }} /><div className="flex items-center custom-target-icon flex-nowrap" {...TooltipAttributes({ categorydescription: "KPIs that are below target but have improved from last year, reflecting positive progress." })}><span className="text-base font-[400] mx-2">Improvement Shown</span></div>
                                </div>
                            </div>
                        </div>
                        <LoaderContainer loading={Improvement_Tile_Reportdataloading} width={"100%"} height={"245px"} className={'bg-slate-800'}>

                            <Carousel value={Improvement_Tile_Reportdata} numVisible={7} numScroll={1} orientation="vertical" verticalViewPortHeight={screenWidth < 1040 ? "320px" : "295px"}
                                itemTemplate={improvement} />
                        </LoaderContainer>
                    </div>
                </div>
                <div className="wrapper-card2 w-full mx-2">
                    <div className="streweak-vertical-carousel">
                        <div className="">
                            <div className='flex justify-between items-center bg-[#0F0D0B] h-[40px] pr-2'>
                                <div className="px-3 flex items-center justify-start">
                                    <img src={thumbdown} style={{ height: 18, width: 18 }} /><div className="flex items-center custom-target-icon flex-nowrap" {...TooltipAttributes({ categorydescription: "KPIs that are below target and have declined compared to last year, indicating areas of concern." })}><span className="text-base font-[400] mx-2">Weaknesses</span></div>
                                </div>
                            </div>
                        </div>
                        <LoaderContainer loading={Weakness_Tile_Reportdataloading} width={"100%"} height={"245px"} className={'bg-slate-800'}>

                            <Carousel value={Weakness_Tile_Reportdata} numVisible={5} numScroll={1} orientation="vertical" verticalViewPortHeight={screenWidth < 1040 ? "320px" : "295px"}
                                itemTemplate={weakness} />
                        </LoaderContainer>
                    </div>
                </div>
            </div>
            <div className="card wrapper-card text-white mx-5 my-3">
                <Card title="">
                    <div className="flex justify-between studenteoc-civi">
                        <div className="title-text flex items-center">{selectedmetricname}</div>
                        <div className="flex justify-center">
                            <div className="mx-1">
                                <label htmlFor="dd-city" className="labeltext">Dimension 1</label>
                                <Dropdown value={selectedoptions} onChange={(e) => setSelectedoptions(e.value)} options={options1.filter(item => item.value != selectedoptions1 && item.value != selectedoptions3 && item.value != selectedoptions2)} optionLabel="name"
                                    placeholder="School Type" className="w-full md:w-14rem" />
                            </div>
                            <div className="mx-1">
                                <label htmlFor="dd-city" className="labeltext">Dimension 2</label>
                                <Dropdown value={selectedoptions1} onChange={(e) => setSelectedoptions1(e.value)} options={options1.filter(item => item.value != selectedoptions2 && item.value != selectedoptions3 && item.value != selectedoptions)} optionLabel="name"
                                    placeholder="Ethnicity" className="w-full md:w-14rem" />
                            </div>
                            <div className="mx-1">
                                <label htmlFor="dd-city" className="labeltext">Dimension 3</label>
                                <Dropdown value={selectedoptions2} onChange={(e) => setSelectedoptions2(e.value)} options={options1.filter(item => item.value != selectedoptions1 && item.value != selectedoptions3 && item.value != selectedoptions)} optionLabel="name"
                                    placeholder="Grade Level" className="w-full md:w-14rem" />
                            </div>
                            <div className="mx-1">
                                <label htmlFor="dd-city" className="labeltext">Dimension 4</label>
                                <Dropdown value={selectedoptions3} onChange={(e) => setSelectedoptions3(e.value)} options={options1.filter(item => item.value != selectedoptions && item.value != selectedoptions1 && item.value != selectedoptions2)} optionLabel="name"
                                    placeholder="Gender" className="w-full md:w-14rem" />
                            </div>
                            {/* <div className='text-[#fff] text-xs w-1'><Link><i class="pi pi-ellipsis-v"></i></Link></div> */}
                        </div>
                    </div>
                    <LoaderContainer loading={STRENGTH_AND_WEAKNESS_DRILL_DOWN_CHARTdata.length > 0 ? false : true} width={"100%"} height={"400px"} className={'bg-slate-800'}>
                        <div className="m-0 text-white flex items-center justify-start">
                            {/* <ReactEcharts option={drilldown} style={{ width: '70%',height:'500%' }} /> */}

                            {/* <LoaderContainer loading={STRENGTH_AND_WEAKNESS_DRILL_DOWN_CHARTloading} height={180} width={'100%'}> */}



                            {STRENGTH_AND_WEAKNESS_DRILL_DOWN_CHARTdata.length > 0 ? <TreeMapEcharts
                                handleTreeOnClick={handleTreeOnClick}
                                data={finalDrilldownChartData}
                                nestedFields={nestedFields} valueFields={valueFields}
                                percentageFields={percentageFields}
                                // loading={ STRENGTH_AND_WEAKNESS_DRILL_DOWN_CHARTloading }
                                loading={STRENGTH_AND_WEAKNESS_DRILL_DOWN_CHARTdata.length === 0}
                            //  shareFields={shareFields}
                            /> : <div className="h-[350px]"></div>}

                        </div>
                    </LoaderContainer>
                    <div className="text-white text-[14px]">Note: Click on the circle to see the next dimension</div>
                </Card>
            </div>
            <div className="py-4 flex justify-end">
                    <div className="flex items-end">
                        <span className="text-white">Powered By </span>
                        <img src={Edvisiondarklogo} height="75px" width="150px" alt="logo" />
                    </div>
                </div>
        </div>
    )
}


export const formatActualValue = (actual, metricName, LastYearValue) => {
    const fixedMetrics = [
        "i-Ready Benchmark Assessment - Reading",
        "i-Ready Benchmark Assessment - Math",
        "iReady Benchmark Assessment(Math)",
        "iReady Benchmark Assessment(Reading)",
        "PSAT (College Board) ",
        "SAT (College Board) ",
        "College Board (PSAT Assessment)",
        "College Board (SAT Assessment)",
        "College Board Assessment(Grade 6 &7)- SAT",
        "College Board Assessment(Grade 2 & 4)- PSAT",
        "# of Minor incidents", "# of Major incidents",
        "College Board (PSAT)", "College Board (SAT)",
    ];


    // return fixedMetrics.includes(metricName) ? Number(actual)?.toLocaleString(undefined, { maximumFractionDigits: 0 }) : (Number(actual)?.toFixed(1) == 0 && LastYearValue ? LastYearValue + "%" : Number(actual)?.toFixed(1) + `%`);
    return fixedMetrics.includes(metricName) ? Number(actual)?.toLocaleString(undefined, { maximumFractionDigits: 0 }) : Number(actual)?.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + `%`;
};